import { UNDEF } from "Constants";
import React, { useState, ReactElement } from "react";
import Tooltip from "Components/Tooltip";
import './style.css';

export type ChipsPropType = {
  id?: string;
  label: string;
  active?: boolean;
  showInfoButton?: boolean;
  data?: any;
  toolTipText?: string;
  onClick: (data?: any) => void;
  onClickInfoButton?: () => void;
}

const Chips = (props: ChipsPropType) => {
  const { id, label, toolTipText, active, showInfoButton, data, onClick, onClickInfoButton } = props;
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const _renderTooltip = (): ReactElement | null => {
    if (showTooltip) {
      return <Tooltip label={toolTipText} />;
    }

    return null;
  };



  const _renderInfoButton = (): ReactElement | null => {
    if (!showInfoButton) {
      return null;
    }

    return <div
      className="info-container"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      data-testid="chip-tooltip"
    >
      <button
        onClick={() => onClickInfoButton && onClickInfoButton()}
        className='chip-info-button'
        data-testid="chip-tooltip-button"
      >
        <img alt='info' src='/info.png' />
      </button>
      {_renderTooltip()}
    </div>;
  };

  return <div className='chip-container'>
    {_renderInfoButton()}
    <span className={active ? 'chip-text' : 'chip-text-inactive'}>{label}</span>
    <button
      onClick={() => onClick(data)}
      className='chip-close-button'
      data-testid="chip-close-button"
    >
      <img alt='delete' src='/close_small.png' />
    </button>
  </div>;
}

export default Chips;